import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromNotification from './reducers/notification.reducer';
import { EffectsModule } from '@ngrx/effects';
import { NotificationEffects } from './effects/notification.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('notification', fromNotification.reducer),
    EffectsModule.forFeature([NotificationEffects])
  ]
})
export class NotificationModule { }
